import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import {
  Receipt,
  CheckCircleOutline,
  ErrorOutline,
  AccountBalanceWallet,
} from "@mui/icons-material";

const SummaryCard = ({ icon, title, amount, color }) => {
  return (
    <Paper
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        borderRadius: 2,
        border: `1px solid ${color}20`,
      }}
    >
      <Box
        sx={{
          bgcolor: `${color}20`,
          p: 1.5,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" color="text.secondary" fontSize="0.85rem">
          {title}
        </Typography>
        <Typography variant="h6" fontWeight={600} fontSize="1.1rem">
          {amount}
        </Typography>
      </Box>
    </Paper>
  );
};

const AllTransactionsSummary = ({ stats }) => {
  const cards = [
    {
      icon: <Receipt sx={{ color: "#2196f3" }} />,
      title: "Total Transactions",
      amount: stats.totalTransactions,
      color: "#2196f3",
    },
    {
      icon: <CheckCircleOutline sx={{ color: "#4caf50" }} />,
      title: "Successful Transactions",
      amount: stats.successfulTransactions,
      color: "#4caf50",
    },
    {
      icon: <ErrorOutline sx={{ color: "#f44336" }} />,
      title: "Failed Transactions",
      amount: stats.failedTransactions,
      color: "#f44336",
    },
    {
      icon: <AccountBalanceWallet sx={{ color: "#ff9800" }} />,
      title: "Total Earnings",
      amount: `₹${stats.totalEarnings.toFixed(2)}`,
      color: "#ff9800",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {cards.map((card, index) => (
        <Box
          key={index}
          sx={{
            flex: { xs: "1 1 calc(50% - 8px)", md: "1 1 calc(25% - 12px)" },
          }}
        >
          <SummaryCard {...card} />
        </Box>
      ))}
    </Box>
  );
};

export default AllTransactionsSummary;
